import { render, staticRenderFns } from "./ShopifySelect.vue?vue&type=template&id=7fa034a0"
import script from "./ShopifySelect.vue?vue&type=script&lang=js"
export * from "./ShopifySelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports